export default __webpack_public_path__ + "static/media/ic_baseline_work_outline_48px.ca530bd1.svg";